import React from 'react';
import './Institutions.scss';

import fsuLogo from '../../assets/9-logos/fsu-band.png';
import northwesternLogo from '../../assets/9-logos/northwestern-band.png';
import hkustLogo from '../../assets/9-logos/hkust-band.png';
import tongjiLogo from '../../assets/9-logos/tongji-band.png';

/* The four institutions, in colour; the hero and team rows reuse them in grey */
export const INSTITUTIONS: { src: string; alt: string; heroHeight: number }[] = [
  { src: fsuLogo, alt: 'Florida State University', heroHeight: 20 },
  { src: northwesternLogo, alt: 'Northwestern University', heroHeight: 25 },
  { src: hkustLogo, alt: 'HKUST', heroHeight: 25 },
  { src: tongjiLogo, alt: 'Tongji University', heroHeight: 25 },
];

/* Institution band above the footer */
const Institutions: React.FC = () => (
  <section className="logos" id="institutions">
    <div className="band contain">
      {INSTITUTIONS.map((l) => <img key={l.alt} src={l.src} alt={l.alt} style={{ height: 48 }} />)}
    </div>
  </section>
);

export default Institutions;
